// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","455":"60fa4b3a","692":"26a8e61c","800":"dcffa67e","858":"43151117","977":"6a7f6471"}[chunkId] + ".chunk.js";
};